var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.611,
    height: 24.022,
    viewBox: "0 0 35.611 24.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M20.6,11.7a1.594,1.594,0,0,1,.012,2.244l-7.4,7.427H41.42a1.585,1.585,0,0,1,0,3.171H13.212l7.415,7.427a1.605,1.605,0,0,1-.012,2.244,1.579,1.579,0,0,1-2.232-.012L8.333,24.079h0a1.78,1.78,0,0,1-.329-.5,1.513,1.513,0,0,1-.122-.61,1.59,1.59,0,0,1,.451-1.11L18.382,11.737A1.554,1.554,0,0,1,20.6,11.7Z",
    transform: "translate(-7.632 -11.002)",
    fill: "#fefefe",
    stroke: "#fefefe",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowWhite);
export default __webpack_public_path__ + "static/media/backArrowWhite.8adffef36e8acf45d552c90a679a5db7.svg";
export { ForwardRef as ReactComponent };